import { Component, OnInit, ElementRef, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../../../services/lottos/lottos.service';
import { WindowScrollService } from '../../../../services/window-scroll/window-scroll.service';
import { FixedBoxControlService } from 'src/app/services/fixed-box-control/fixed-box-control.service';
import { Language } from 'src/app/tools/language/language';

@Component({
  selector: 'app-about',
  templateUrl: './about.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, AfterViewInit {
  @ViewChild('about', { static: false })
  about: ElementRef;
  public sys: string;
  public subs: Subscription;
  public subsWindowScroll: any;
  public scroll: number = 0;
  public posAbout: number;
  public showAny: boolean = false;
  public idLotto: number;
  public language: Language = new Language();
  public lang: any = Language.currentLanguage.lenid;
  constructor(
    private _renderer: Renderer2,
    private _getWScroll: WindowScrollService,
    private _lotto: LottosService,
    private _fixedBoxControl: FixedBoxControlService
  ) {}

  ngOnInit(): void {
    this.setSystem();
    this.windowScroll();
  }
  ngAfterViewInit(): void {
    this.getPosAbout();
  }

  setSystem(): void {
    this.subs = this._lotto.lottoObservable$.subscribe((lottoObj) => {
      this.idLotto = lottoObj['id'];
      this.sys = lottoObj['system'];
    });
  }

  windowScroll(): void {
    this.subsWindowScroll = this._getWScroll.scroll$.subscribe((pos) => {
      this.scroll = pos;
    });
  }

  getPosAbout(): void {
    this.posAbout = this.about.nativeElement.getBoundingClientRect().top;
  }

  get showFixedBox() {
    return this.scroll >= this.posAbout - 50 ? this.setFixedBox(true) : this.setFixedBox(false);
  }

  setFixedBox(isShow): boolean {
    this._fixedBoxControl.setFixedBox(isShow);
    return isShow;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.subsWindowScroll.unsubscribe();
  }
}
